
import request from '../ajax_request.js'
import {base_url, debug_obj} from "../base_api"


export function selectoption(query){

	let url = `${base_url}/pos/selectoption`;
	console.log(debug_obj);
	let params ={};
	if(query){
		if(!query.nodebug)
			Object.assign(params,debug_obj)
		Object.assign(params,query)
		
	}else{
		Object.assign(params,debug_obj)
	}


	var req = request({
        url,
        method: 'get',
        params:params
    })
	console.log(debug_obj);
    return req;
}


 




// WEBPACK FOOTER //
// ./src/api/module/select_options.js